module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "Title_About.46dc26aa.png";